/*
 * Only the main product section is morphed on AJAX product navigation
 * (product-ajax-navigation.js), so the reviews section would otherwise
 * keep showing the previous product's reviews. Re-render it from the
 * new URL and let Okendo re-initialise the widget inside it.
 */
class ProductReviews extends HTMLElement {
  connectedCallback() {
    this.handleProductRendered = this.handleProductRendered.bind(this);
    document.addEventListener("product:ajax-rendered", this.handleProductRendered);
  }

  disconnectedCallback() {
    document.removeEventListener("product:ajax-rendered", this.handleProductRendered);
  }

  async handleProductRendered(event) {
    const url = event.detail?.url;
    const sectionId = this.getAttribute("section-id");

    if (!url || !sectionId) return;

    const requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set("section_id", sectionId);

    const requestId = (this.requestId = (this.requestId || 0) + 1);

    try {
      const response = await fetch(requestUrl.href);
      if (!response.ok || requestId !== this.requestId) return;

      const html = new DOMParser().parseFromString(await response.text(), "text/html");
      const next = html.querySelector("product-reviews");
      if (!next || next.dataset.productId === this.dataset.productId) return;

      this.dataset.productId = next.dataset.productId;
      this.classList.toggle("product-reviews--empty", next.classList.contains("product-reviews--empty"));

      const title = this.querySelector("[data-product-reviews-title]");
      const nextTitle = next.querySelector("[data-product-reviews-title]");
      if (title && nextTitle) title.innerHTML = nextTitle.innerHTML;

      const widget = this.querySelector("[data-product-reviews-widget]");
      const nextWidget = next.querySelector("[data-product-reviews-widget]");
      if (!widget || !nextWidget) return;

      widget.innerHTML = nextWidget.innerHTML;
      initOkendoWidgets(widget);
    } catch (_) {
      /* Leave the existing reviews in place if the re-render fails. */
    }
  }
}

function initOkendoWidgets(root) {
  const api = window.okeWidgetApi;
  if (!api?.initWidget) return;

  root.querySelectorAll("[data-oke-widget]").forEach((element) => {
    api.initWidget(element, true);
  });
}

customElements.get("product-reviews") || customElements.define("product-reviews", ProductReviews);
